import { COMPANY_URL, SUBSCRIPTION_URL } from "../../helpers/api.routes";
import { instance, requests } from "../../helpers/api.services";
import { CsvExportParams } from "../../shared/components/CsvExportModal";

export const CompanyService = {
  getAll: (params: any) => requests.get(`${COMPANY_URL}`, params),
  create: (params: any) => requests.post(`${COMPANY_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${COMPANY_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${COMPANY_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${COMPANY_URL}/${id}`),

  // Add updateFeatured method
  updateFeatured: (id: number, body: { featured: boolean }) =>
    requests.put(`${COMPANY_URL}/featured/${id}`, body),
  exportCsv: (params: CsvExportParams) =>
    instance.get<Blob>(`${COMPANY_URL}/export`, { params, responseType: 'blob' }),
};

export const SubscriptionService = {
  getCompanyCurrent: (companyId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/company-subscriptions/current/${companyId}`),
  assignCompanyPackage: (params: { company: number; package: number; duration: string }) =>
    requests.post(`${SUBSCRIPTION_URL}/company-subscriptions/assign-package`, params),
  getCompanySubscriptionHistory: (companyId: number) =>
    requests.get(`${SUBSCRIPTION_URL}/company-subscriptions/subscription-history/${companyId}`),
  getPackages: (params: any) => requests.get(`${SUBSCRIPTION_URL}/packages`, params),
};